import template from './comments.html';
import controller from './comments.controller';
import './comments.scss';

let commentsComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default commentsComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/comments/comments.component.js